import InvoiceAutomationRunScheduleEnum from './InvoiceAutomationRunScheduleEnum';

const InvoiceAutomationRunScheduleOptionsArray = [
  { label: 'Automatically, every morning', value: InvoiceAutomationRunScheduleEnum.Daily },
  { label: 'Only on demand', value: InvoiceAutomationRunScheduleEnum.OnDemand },
];

export default InvoiceAutomationRunScheduleOptionsArray;
